import SequenceNumberListResourceModel from '../../generated/types/model/resource/SequenceNumberListResourceModel';

export default class SequenceNumberListResourceViewModel extends SequenceNumberListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
